/**
 * @namespace Abstracts
 */
import Backbone from 'backbone'
import Task from '../models/task'
import Core from '../../core'

/**
 * Coleção de tarefas
 * @name TasksCollections
 * @memberof abstracts/tasks
 * @see {@link https://backbonejs.org/#Collection}
 */
class TasksCollections extends Backbone.Collection {
    model = Task

    /**
     * Inicializa a coleção
     * Adiciona um listerner para cada model Task
     *
     * @return {void}
     */
    initialize () {
        // this.filter((m) => {
        //     if(!m.isValid()) {
        //         console.info("Erro na inserção de tarefa", m.validationError());
        //         this.remove(m);
        //     }
        // })

        this.on('add', this._addListernes, this)
    }

    /**
     * Sobrescreve o método add
     * O prepara para receber mais de um paramêtro dependendo da tarefa
     *
     * @param {any} ...params - Pode ser um ou dois parâmetros
     * @return {void}
     */
    add (...params) {
        super.add(params)
    }

    /**
     * Listerner do evento Add na model Task
     * Adiciona outros listernes ao model Task
     *
     * @param {Task} task - O Evento add envia o model Task como parâmetro
     * @return {void}
     */
    _addListernes (task) {
        // Se um evento executed for disparado do model Task
        // o remove da coleção
        task.on('executed', () => {
            if (!task.get('waiting') || Core.Events.isOnceEvent(task.get('waiting'))) {
                this.remove(task)
            }
        })
    }

    // _checkisValid (model) {
    //     if(!model.isValid()) {
    //         console.info("Erro na inserção de tarefa", model.validationError);
    //         this.remove(model);
    //     }
    // }
}

export default TasksCollections
